import type { MissingRow } from '$/dto/ItineraryData.dto.ts';

export type MissingRowMessage = { key: string; request?: string };

const missingRowMessage = (missing: MissingRow): MissingRowMessage => {
  const request = missing.request_text?.trim();

  return request
    ? { key: `tripPage.missing_row.request.${missing.reason}`, request }
    : { key: `tripPage.missing_row.reason.${missing.reason}` };
};

export default missingRowMessage;
